'use strict';
rcFundRange.$inject = ['$http', '$compile', '$templateCache', '$q', 'accountStructureService'];
angular.module('schoolLinqApp').directive('rcFundRange', rcFundRange);
require('@ajs/templates/reports/rcFundRange.html');
require('@ajs/templates/reports/rcFundRangeSlimDisplay.html');

function rcFundRange($http, $compile, $templateCache, $q, accountStructureService) {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			ngModel: '=',
			isDisabled: '=',
			isSlimDisplay: '=',
		},
		replace: true,
		restrict: 'E',
		link: function (scope, iElement, iAttrs) {
			var tempUrl = '/templates/reports/rcFundRange.html';
			if (scope.isSlimDisplay === true) {
				tempUrl = '/templates/reports/rcFundRangeSlimDisplay.html';
			}
			$http.get(tempUrl, { cache: $templateCache }).success(function (tplContent) {
				iElement.replaceWith($compile(tplContent)(scope));
			});
		},
		controller: [
			'$scope',
			function ($scope) {
				$scope.viewModel = {
					unifiedFundMask: null,
					elements: [],
					fundElement: '',
				};
				$scope.ngModel = [
					{
						queries: [{}],
					},
				];

				$scope.loadingElementRange = $q.all([loadAccountStructures()]);

				function loadAccountStructures() {
					return accountStructureService.getStructure().then(finishLoadingAccountStructures);

					function finishLoadingAccountStructures(response) {
						let unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
						let unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;
						if (unifiedAccountMask !== null) $scope.viewModel.unifiedFundMask = unifiedAccountMask.split('.')[unifiedFundElementIndex];

						// get the Fund name (just get it from the Asset Element Map since it will be the same for all the types)
						$scope.viewModel.fundElement = response.data.accountStructure.AssetElementMap.split('.')[
							response.data.accountStructure.AssetElementFundIndex
						];
						$scope.viewModel.elements.push($scope.viewModel.fundElement);

						return angular.noop;
					}
				}

				$scope.queryOptions = [
					{
						displayName: 'is > or =',
						query: 'greaterthanorequal',
					},
					{
						displayName: 'is < or =',
						query: 'lessthanorequal',
					},
					{
						displayName: 'is >',
						query: 'greaterthan',
					},
					{
						displayName: 'is <',
						query: 'lessthan',
					},
					{
						displayName: '=',
						query: 'equal',
					},
				];

				$scope.addQuery = function (filter) {
					filter.queries.push({});
				};

				$scope.removeQuery = function (filter, query) {
					let index = _.findIndex(filter.queries, {
						$$hashKey: query.$$hashKey,
					});
					filter.queries.splice(index, 1);
				};
			},
		],
	};
}
